<div class="form-field" (click)="focus()">
  <div class="form-field__control">
    <ng-content select="[input]"> </ng-content>
    <ng-content select="[label]"> </ng-content>
  </div>
</div>

<ng-content select="[help]"></ng-content>
